/** @jsx jsx */

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

import AppListItem from 'app/zapbook/components/AppListItem';
import Categories from 'app/zapbook/components/Categories';
import PageSection from 'app/common/components/PageSection';
import RequestAddUpdates from 'app/zapbook/components/RequestAddUpdates';
import matchesMediaQuery from 'app/common/components/matchesMediaQuery';
import purify from 'app/common/components/purify';
import { SMALL_SCREEN } from 'app/zapbook/utils/constants';

const Styles = {
  flexContainer: asSubsection => ({
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'row wrap',
    ...(asSubsection && {
      overflowY: 'hidden',
      minHeight: '65vh',
      margin: '0 auto',
    }),
  }),
  appList: asSubsection => ({
    width: '100%',
    [`@media (min-width: ${SMALL_SCREEN})`]: {
      backgroundColor: Colors.white,
      width: '70%',
      paddingTop: '1.2em',
      overflowX: 'hidden',
    },
    ...(asSubsection && {
      height: '65vh',
      overflowY: 'auto',
      margin: '0 auto',
    }),
  }),
};

const AppList = props => {
  const showCategories =
    !props.isOneServicePage && !props.matchesMediaQuery.narrow;
  const asSubsection = !props.isZapbookPage && !props.isCategoryPage;
  return (
    <div className="container">
      <PageSection
        className="app-picker-list"
        css={Styles.flexContainer(asSubsection)}
        id="appsListWrapper"
      >
        <div css={Styles.appList(asSubsection)}>
          <ul>
            {_.map(props.services, service => (
              <AppListItem key={service.id} {...service} />
            ))}
          </ul>
        </div>
        {showCategories ? (
          <Categories
            categoryTypes={props.categoryTypes}
            filterBy={props.filterBy}
            filterCategories={props.filterCategories}
            isCategoryPage={props.isCategoryPage}
            isZapbookPage={props.isZapbookPage}
            onSortOrFilter={props.onSortOrFilter}
            requestAddUpdates={props.requestAddUpdates}
            sortBy={props.sortBy}
            sortCategories={props.sortCategories}
          />
        ) : null}
        {!props.isZapbookPage && !props.isCategoryPage ? (
          <RequestAddUpdates {...props.requestAddUpdates} />
        ) : null}
      </PageSection>
    </div>
  );
};

AppList.propTypes = {
  services: PropTypes.arrayOf(PropTypes.object.isRequired),
  sortBy: PropTypes.string.isRequired,
  filterBy: PropTypes.string.isRequired,
  sortCategories: PropTypes.array.isRequired,
  filterCategories: PropTypes.array.isRequired,
  onSortOrFilter: PropTypes.func.isRequired,
  categoryTypes: PropTypes.object.isRequired,
  isZapbookPage: PropTypes.bool.isRequired,
  isOneServicePage: PropTypes.bool.isRequired,
  requestAddUpdates: PropTypes.object.isRequired,
};

export default matchesMediaQuery({ narrow: SMALL_SCREEN })(purify(AppList));
